import React from 'react'
import './style.css'

const FormField = ({ ...props }) => (
	<input {...props} />
)

export default FormField